import React, { Component, Fragment } from "react";

// Externals
import classNames from "classnames";
import compose from "recompose/compose";
import PropTypes from "prop-types";

// Material helpers
import { withStyles, withWidth, CircularProgress } from "@material-ui/core";

// Material components
import { Drawer } from "@material-ui/core";

// Custom components
import { Sidebar, Topbar, Chat, RightSidebar } from "./components";

// Component styles
import { styles } from "./styles";

// Redux
import { setWidth } from "../../redux/actions/layoutActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PopUpMessages from "../../components/PopUpMessages/PopUpMessages";
import { removeMessage } from "../../redux/actions/commonActions";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    const isMobile = ["xs", "sm"].includes(props.width);

    this.state = {
      isMobile: ["xs", "sm"].includes(props.width),
      // window.self === window.top checks if the webapp is showed in an iframe
      sidebarIsOpen: !isMobile && window.self === window.top,
      rightSidebarIsOpen: false
    };
  }

  componentDidMount() {
    this.props.setWidth(this.state);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.someValue !== prevState.someValue) {
      return { someState: nextProps.someValue };
    } else return null;
  }

  toggleRightSidebar = e => {
    if (!this.state.rightSidebarIsOpen) {
      this.setState(
        {
          rightSidebarIsOpen: e.currentTarget.id
        },
        () => {
          if (this.state.isMobile) {
            this.props.setWidth(this.state);
          }
        }
      );
    } else if (e.currentTarget.id !== this.state.rightSidebarIsOpen) {
      this.setState(
        {
          rightSidebarIsOpen: e.currentTarget.id
        },
        () => {
          if (this.state.isMobile) {
            this.props.setWidth(this.state);
          }
        }
      );
    }
  };

  handleClose = () => {
    this.setState({ sidebarIsOpen: false }, () => {
      this.props.setWidth(this.state);
    });
  };

  handleToggleOpen = () => {
    this.setState(
      prevState => ({
        sidebarIsOpen: !prevState.sidebarIsOpen
      }),
      () => {
        this.props.setWidth(this.state);
      }
    );
  };

  renderSpinner() {
    const { classes, isLoading, children } = this.props;
    if (isLoading) {
      return (
        <div className={classes.progressWrapper}>
          <CircularProgress />
        </div>
      );
    }
    return <React.Fragment>{children}</React.Fragment>;
  }

  render() {
    const { classes, width, title, message, preventDuplicate, removeMessage } = this.props;
    const { sidebarIsOpen, rightSidebarIsOpen } = this.state;

    const isMobile = ["xs", "sm"].includes(width);
    const leftShift = sidebarIsOpen && !isMobile;
    const leftRightShift = leftShift && rightSidebarIsOpen && !isMobile;
    const chatToHide = () => {
      if (this.props.removeChat) {
        //console.log("hidden chat");
        return <div></div>;
      }

      return <Chat sidebarIsOpen={sidebarIsOpen} />;
    };

    // window.self === window.top checks if the webapp is showed in an iframe
    //    let iFrameDetection = (window === window.parent) ? false : true;
    let iFrameDetection = window.self === window.top ? false : true;
    //    console.log(iFrameDetection);

    return (
      <Fragment>
        <Topbar
          className={classNames(classes.topbar, {
            [classes.rightTopbarShift]: rightSidebarIsOpen && !isMobile,
            [classes.leftTopbarShift]: leftShift,
            [classes.leftRightTopbarShift]: leftRightShift
          })}
          isSidebarOpen={sidebarIsOpen}
          onToggleSidebar={this.handleToggleOpen}
          toggleRightSidebar={this.toggleRightSidebar}
          title={title}
          isMobile={isMobile}
          iFrameDetection={iFrameDetection}
        />
        <Drawer
          anchor="left"
          classes={{ paper: classes.drawerPaper }}
          onClose={this.handleClose}
          open={sidebarIsOpen}
          variant={isMobile ? "temporary" : "persistent"}
          //          className={iFrameDetection ? "mui-drawer-hidden" : "mui-drawer-show-it"}
        >
          <Sidebar className={classes.sidebar} />
        </Drawer>

        {/*<div style={{ paddingLeft: "270px", height: "100%" }}>*/}
        <main
          className={classNames(classes.content, {
            [classes.leftContentShift]: leftShift,
            [classes.rightContentShift]: rightSidebarIsOpen && !isMobile
          })}
        >
          {this.renderSpinner()}

          {chatToHide()}
        </main>
        {/*</div>*/}
        {rightSidebarIsOpen ? (
          <RightSidebar
            context={this.props.title}
            content={rightSidebarIsOpen}
            toggleRightSidebar={this.toggleRightSidebar}
            isMobile={isMobile}
          />
        ) : (
          <span />
        )}
        <PopUpMessages message={message} removeMessage={removeMessage} preventDuplicate={preventDuplicate} />
      </Fragment>
    );
  }
}

Dashboard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  width: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    message: state.common.message,
    preventDuplicate: state.common.preventDuplicate
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        setWidth,
        removeMessage
      },
      dispatch
    ),
    dispatch
  };
}

Dashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);

export default compose(
  withStyles(styles),
  withWidth()
)(Dashboard);
